<template>
  <div class="devices-max-width-my-account">
    <div
      class="
      header-container
      gds-flex-container--left
      devices-gap-2 gds-flex-container--wrap
      gds-flex-container gds-flex-container--space-between"
    >
      <h3 class="gds-font-medium gds-space-stack-s">My Impact</h3>
      <span v-if="vm.customDateRangeLabel" class="gds-font-book gds-font-size-m">{{ vm.customDateRangeLabel }}</span>
      <span v-if="vm.customDateRangeError" class="gds-font-book gds-font-size-m gds-text-red">Custom date range must not exceed one year.</span>
      <HybridDateSelectControl :config="vm.devicesSelectControlConfig" :option-selected="onDateRangeSelected" />
    </div>
    <div v-if="!vm.loadState" class="table-loading" />
    <ImpactCardGrid v-if="impactsLoaded" :impacts="vm.impacts" />
    <flow-error
      v-if="vm.loadState === 'error'"
      name="Impact information"
      state="unavailable"
      img="/wp-content/themes/gmptwentynineteen/assets/images/usage-not-supported.svg"
    />
  </div>
</template>

<script>
import MyImpactListViewModel from './MyImpactListViewModel';
import ImpactCardGrid from '../../shared/components/impactcard/ImpactCardGrid.vue';
import HybridDateSelectControl from '../../../../shared/datepicker/HybridDateSelectControl.vue';

export default {
  name: 'MyImpactList',
  components: {
    ImpactCardGrid,
    HybridDateSelectControl,
  },
  data() {
    return {
      vm: new MyImpactListViewModel(),
    };
  },
  computed: {
    currentAccount() {
      return this.$store.state.user.currentAccount;
    },
    impactsLoaded() {
      return this.vm.loadState === 'complete' && this.vm.impacts && this.vm.impacts.length;
    },
  },
  mounted() {
    this.vm.currentAccount = this.currentAccount;
    this.onDateRangeSelected(this.vm.devicesSelectControlConfig.selectedValue);
  },
  methods: {
    async onDateRangeSelected($event) {
      this.vm.onDateRangeSelected($event);
    },
  },
};
</script>
